import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useCurrentAccount } from "../../../hooks/useCurrentAccount";
import { RCSService } from "../../../services/RCSService";
import { AlertService } from "../../../services/Alert";
import { useTranslation } from "react-i18next";
import Aside from "../../../components/Aside";
import CustomDataTable from "../../../components/CustomDataTable";
import Footer from "../../../components/Footer";
import Header from "../../../components/Header";
import useRequest from "../../../hooks/useRequest";


function TemplatesPage() {

    const { t } = useTranslation();
    const { call, isRequesting } = useRequest();
    const { account } = useCurrentAccount();
    const navigate = useNavigate();
    const [rows, setRows] = useState([])

    const columns = [
        {
            name: t("platform.channels.templates.name"),
            sortable: true,
            width: 20,
            selector: (row: any) => {

                return (
                    <>
                        <h3 className="h4 text-inherit">{row.name}</h3>
                    </>
                )
            },
        },
        {
            name: t("platform.channels.templates.status"),
            sortable: true,
            width: 20,
            selector: (row: any) => {
                switch (row.status) {
                    case 'APPROVED':
                        return <span className="badge bg-soft-info text-info fs-5"><i className="bi-check-circle-fill"></i> Activo</span>
                    case 'DISABLED':
                        return <span className="badge bg-soft-danger text-danger fs-5"><i className="bi bi-dash-circle"></i> Inactivo</span>
                    default:
                        return <span className="badge bg-soft-dark text-dark"><span className="legend-indicator bg-dark"></span> {row.status} </span>
                }
            },
        },
        {
            name: t("platform.channels.templates.preview"),
            sortable: true,
            width: 30,
            selector: (row: any) => {
                // console.log(row.body)
                const template = JSON.parse(row.body);
                const header = template.find((t: any) => t.type === 'HEADER')
                const body = template.find((t: any) => t.type === 'BODY')
                const buttons = template.find((t: any) => t.type === 'BUTTONS')
                // console.log(header)
                return (
                    <div className="col-4">
                        <div className="wrap-android-table">
                            <div className="preview-container-RCS-table">
                                <div className="preview-template-RCS-table">
                                    {header && header.format === 'TEXT' && (
                                        <div className="preview-template-header fw-bold text-dark">{header.text}</div>
                                    )}
                                    {header && header.format === 'IMAGE' && (
                                        <div className="preview-template-header">
                                            {!header.url && <div className="preview-template-img-container"></div>}
                                            {header.url && (
                                                <div
                                                    className="preview-template-img-container-url"
                                                    style={{ backgroundImage: `url(${header.url})` }}
                                                ></div>
                                            )}
                                        </div>
                                    )}
                                    {header && header.format === 'VIDEO' && (
                                        <div className="preview-template-header">

                                            {!header.url && <div className="preview-template-video-container"></div>}
                                            {header.url && <video className="preview-template-video-container"><source src={header.url} /></video>}

                                            {!header.url && <span className="badge bg-soft-danger text-danger">Sin video</span>}
                                            {header.url && <a href={header.url} target="_blank" rel="noreferrer"><span className="badge bg-soft-primary text-primary">Da clic aquí para visualizar video</span></a>}
                                        </div>
                                    )}
                                    <div className="text-dark mb-3" dangerouslySetInnerHTML={{ __html: body.text.replace(/\n/g, '<br/>') }}></div>

                                    {buttons && (
                                        <div className="">
                                            {buttons.buttons.map((btn: any, index: any) => (
                                                <div key={index} className={`preview-template-btn text-btn-rcs d-flex align-items-center justify-content-center${index !== 0 ? ' border-top mt-2 pt-2 divider-btn-rcs' : ''}`}>
                                                    {btn.type === 'URL' && (
                                                        <>
                                                            <i className="bi bi-globe-americas"></i> {btn.text}
                                                        </>
                                                    )}
                                                    {btn.type === 'QUICK_REPLY' && (
                                                        <>
                                                            <i className="bi bi-send"></i> {btn.text}
                                                        </>
                                                    )}
                                                    {btn.type === 'QUICK_REPLY_DISABLE_MKT' && (
                                                        <>
                                                            <i className="bi bi-dash-circle"></i> {btn.text}
                                                        </>
                                                    )}
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>

                )
            },
        },
        {
            name: t("platform.channels.templates.actions"),
            sortable: false,
            with: 10,
            cell: (row: any) => {
                const isApproved = row.status === "APPROVED";
                const action = isApproved ? "Desactivar" : "Activar";
                return (
                    <div className="btn-group" role="group">
                        <button type="button" className="btn text-white-dark bg-soft-info-alternative btn-sm" onClick={() => statusTemplate(row)}>
                            <i className="bi bi-dash-circle text-primary"></i> <span className="ms-1">{action} plantilla</span>
                        </button>
                        <div className="btn-group">
                            <button title="dorpdown" type="button" className="btn bg-soft-info-alternative btn-icon btn-sm dropdown-toggle dropdown-toggle-empty" data-bs-toggle="dropdown" aria-expanded="false"></button>
                            <div className="dropdown-menu dropdown-menu-end mt-1" >
                                <button type="button" className="dropdown-item" onClick={() => deleteTemplate(row)}>
                                    <i className="bi-trash text-danger"></i> <span className="ms-1">Borrar plantilla</span>
                                </button>
                            </div>
                        </div>
                    </div>
                )
            }
        }

    ];

    const deleteTemplate = async (template: any) => {
        await AlertService.warning('¡ Atención !', `¿Estás seguro de querer borrar esta plantilla?. Esta acción no se puede revertir.`, async () => {
            try {
                await RCSService.delete(account.id, template.id)
                await getTemplates()
                AlertService.toastSuccess('Se Eliminó correctamente la plantilla.')
            } catch (error) {
                console.error(error);
                AlertService.error('¡Error!', error || 'Ocurrió un error al eliminar la plantilla, intenta nuevamente')
            }
        });
    }

    const statusTemplate = async (template: any) => {
        const isApproved = template.status === "APPROVED";
        const action = isApproved ? "desactivar" : "activar";
        const status = isApproved ? "DISABLED" : "APPROVED";

        const data = {
            id: template.id,
            account_id: account.id,
            status: status
        };

        try {
            await AlertService.warning('¡ Atención !', `¿Deseas ${action} la plantilla: ${template.name}?`, async () => {
                await RCSService.statusTemplates(data);
                await getTemplates();
                AlertService.toastSuccess('¡ Éxito !, Se cambió el estado de tu plantilla.');
            });
        } catch (error) {
            console.error(error);
            AlertService.error('¡Error!', error.message || 'Ocurrió un error al actualizar la plantilla, intenta nuevamente');
        }
    };

    const getTemplates = async () => {
        const { data } = await call(() => RCSService.getTemplates(account.id));
        setRows(data)
    }

    useEffect(() => {
        getTemplates()
    }, [])


    return (
        <>
            <Header />
            <Aside />
            <main id="content" role="main" className="main">
                <div className="content container-fluid">
                    <div className="page-header">
                        <div className="row align-items-center">
                            <div className="col-sm mb-2 mb-sm-0">
                                <nav aria-label="breadcrumb">
                                    <ol className="breadcrumb breadcrumb-no-gutter">
                                        <li className="breadcrumb-item "><span className="breadcrumb-link" >Plataforma</span></li>
                                        <li className="breadcrumb-item "><span className="breadcrumb-link" >Canales</span></li>
                                        <li className="breadcrumb-item active" aria-current="page">RCS</li>
                                    </ol>
                                </nav>
                            </div>
                        </div>
                        <div className="row align-items-center mt-3">
                            <div className="col-sm mb-2 mb-sm-0 d-flex align-items-center">
                                <button title="back-btn" type="button" className="btn text-white-dark bg-soft-info-alternative btn-icon me-3" onClick={() => navigate(-1)}>
                                    <i className="bi-chevron-left"></i>
                                </button>
                                <h2 className="page-header-title m-0 me-3 text-dark">Plantillas RCS</h2>
                            </div>
                            <div className="col-sm-auto">
                                <button title="add-template" type="button" className="btn btn-primary btn-sm" onClick={() => navigate('/channels/templatesRCS/create-template')}><i className="bi-plus-lg"></i> {t("platform.channels.templates.btn-create")} </button>
                            </div>
                        </div>
                    </div>
                    <CustomDataTable
                        columns={columns}
                        data={rows}
                        hideAccountsFilter
                        isLoading={isRequesting}
                        filter={(row, term) => {
                            if (!term) return true;

                            return (
                                `${row.name}`.match(new RegExp(`${term}`, 'i')) ||
                                `${row.status}`.match(new RegExp(`${term}`, 'i')) ||
                                `${row.body}`.match(new RegExp(`${term}`, 'i')) ||
                                `${row.language}`.match(new RegExp(`${term}`, 'i'))
                            )
                        }}
                    />
                </div>
                <Footer />
            </main>
        </>
    )
}
export default TemplatesPage